import React from "react"
import gql from "graphql-tag"
import {set, cloneDeep, isString, isObject} from "lodash"

import {Mutation} from "../../mutation"
import GetInsWizard from "../query/InsWizard"

export const insWizardMutation = gql`
  mutation InsWizardMutation($params: InsWizardParams) {
    insWizard(params: $params) @client
  }
`

const UpdateInsWizard = ({children, ...props}) => {
  return (
    <GetInsWizard>
      {({cycle, questions}) => {
        return (
          <Mutation {...props} mutation={insWizardMutation} ignoreResults>
            {(mutate, apolloState) => {
              return children(
                (...args) => mutate(...args),
                {
                  updateCycle: (_, property, value) => {
                    const oldCycle = cloneDeep(cycle)

                    if (isString(property)) set(oldCycle, property, value)

                    if (isObject(property)) {
                      Object.keys(property).forEach((key) => set(oldCycle, key, property[key]))
                    }

                    return mutate({variables: {params: {cycle: oldCycle}}})
                  },
                  ...apolloState,
                  cycle,
                  questions
                }
              )
            }}
          </Mutation>
        )
      }}
    </GetInsWizard>
  )
}


export default UpdateInsWizard
